module.exports = __webpack_public_path__ + "media/reskin-images/icon--headphones-2-36c56647.svg";